import React, { forwardRef } from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';
import { SmartCardProvider } from '@atlaskit/link-provider';
import { Box } from '@atlaskit/primitives/compiled';

import { useAIAnswerContext } from '../../ai-answer-dialog/ai-answer-context';
import {
	getSmartLinksAnalyticsContextData,
	SmartLinksAnalyticsContextLocation,
} from '../../ai-answer-dialog/analytics';
import { ReactRenderer } from '../common/ui/react-renderer';

export const SmartAnswerCardBodyTabAIAnswer = forwardRef<HTMLDivElement>((props, ref) => {
	const { commonAttributes } = useAIAnswerContext();
	const { answerString } = commonAttributes;

	return (
		<AnalyticsContext
			data={getSmartLinksAnalyticsContextData({
				location: SmartLinksAnalyticsContextLocation.SAIN_Q_AND_A_CARD,
				commonAttributes,
			})}
		>
			<SmartCardProvider>
				<Box id="ai-answer-result-section" ref={ref}>
					<ReactRenderer markdown={answerString} />
				</Box>
			</SmartCardProvider>
		</AnalyticsContext>
	);
});

SmartAnswerCardBodyTabAIAnswer.displayName = 'SmartAnswerCardBodyTabAIAnswer';
